/**
 * Онбординг — семь экранов ТЗ (1–7), тексты дословно.
 *
 * Порядок шагов задаёт `ONBOARDING_STEPS`: адрес /onboarding/<step>, по нему
 * же считается прогресс. Иконки — имена из набора в компоненте шага, чтобы
 * контент оставался чистыми данными.
 */
export const ONBOARDING_STEPS = ["start", "how", "effect", "why", "goal", "params", "done"] as const;

export type OnboardingStep = (typeof ONBOARDING_STEPS)[number];

export const start = {
  title: "Тирзепатид — новый подход к снижению веса",
  subtitle: "Узнайте, как он работает, какого эффекта можно ожидать и как начать.",
  button: "Начать",
  skipPrefix: "Уже знаком с препаратом",
  skipLink: "Перейти к продукту",
} as const;

export const how = {
  title: "Как работает тирзепатид?",
  body: "Тирзепатид воздействует на механизмы, связанные с аппетитом и чувством насыщения. Благодаря этому становится проще контролировать питание и постепенно снижать вес.",
  cards: [
    { icon: "hunger", title: "Меньше чувства голода", body: "Аппетит становится легче контролировать." },
    { icon: "plate", title: "Насыщение наступает раньше", body: "Проще контролировать размер порций." },
    { icon: "brain", title: "Меньше тяги к еде", body: "Еда занимает меньше внимания в течение дня." },
  ],
  button: "Далее",
} as const;

export const effect = {
  title: "Изменения происходят постепенно",
  timeline: [
    { icon: "start", title: "Начало", body: "Организм адаптируется к препарату." },
    { icon: "food", title: "Следующий этап", body: "Может снижаться аппетит и становиться проще контролировать питание." },
    { icon: "active", title: "Со временем", body: "При соблюдении рекомендаций снижение веса может продолжаться постепенно." },
  ],
  caption: "Результаты индивидуальны и могут отличаться.",
  button: "Далее",
} as const;

export const why = {
  title: "Почему выбирают тирзепатид",
  cards: [
    { icon: "plate", title: "Контроль аппетита", body: "Помогает снизить чувство голода и проще придерживаться выбранного режима питания." },
    { icon: "brain", title: "Меньше food noise", body: "Меньше постоянных мыслей о еде и желания перекусить." },
    { icon: "chart", title: "Постепенный результат", body: "Изменения происходят постепенно и формируются со временем." },
    { icon: "drug", title: "Удобный формат", body: "Препарат применяется по установленной схеме в соответствии с рекомендациями специалиста." },
  ],
  button: "Продолжить",
} as const;

export const goal = {
  title: "Какая ваша главная цель?",
  subtitle: "Выберите один вариант.",
  button: "Далее",
} as const;

export const params = {
  title: "Расскажите немного о себе",
  subtitle: "Эти данные помогут персонализировать информацию внутри приложения.",
  sex: "Пол",
  height: "Рост",
  heightUnit: "см",
  weight: "Вес",
  weightUnit: "кг",
  bmiPreview: "Ваш BMI",
  button: "Продолжить",
  skip: "Пропустить",
} as const;

export const done = {
  title: "Готово",
  body: "Мы сохранили ваши данные и настроили приложение под вашу цель.",
  goal: "Ваша цель",
  height: "Рост",
  weight: "Вес",
  bmi: "BMI",
  button: "Перейти к Tirzepatide",
} as const;
